export const API_ERROR_CODE_I18N_REASON_BUSINESS_WORKFLOW: Record<string, string> = {
  access_token_missing: "common.errors.apiCodeReasons.businessWorkflow.accessTokenMissing",
  activity_create_not_ready: "common.errors.apiCodeReasons.businessWorkflow.activityCreateNotReady",
  activity_not_adjustable: "common.errors.apiCodeReasons.businessWorkflow.activityNotAdjustable",
  activity_not_observable: "common.errors.apiCodeReasons.businessWorkflow.activityNotObservable",
  activity_not_reviewable: "common.errors.apiCodeReasons.businessWorkflow.activityNotReviewable",
  activity_not_scoreable: "common.errors.apiCodeReasons.businessWorkflow.activityNotScoreable",
  actor_required: "common.errors.apiCodeReasons.businessWorkflow.actorRequired",
  all_scope_requires_admin: "common.errors.apiCodeReasons.businessWorkflow.allScopeRequiresAdmin",
  already_assigned_to_target_seat:
    "common.errors.apiCodeReasons.businessWorkflow.alreadyAssignedToTargetSeat",
  apply_requires_draft: "common.errors.apiCodeReasons.businessWorkflow.applyRequiresDraft",
  archive_requires_closed: "common.errors.apiCodeReasons.businessWorkflow.archiveRequiresClosed",
  archived_readonly: "common.errors.apiCodeReasons.businessWorkflow.archivedReadonly",
  asset_ref_required: "common.errors.apiCodeReasons.businessWorkflow.assetRefRequired",
  assigned_by_required: "common.errors.apiCodeReasons.businessWorkflow.assignedByRequired",
  attempt_review_status_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.attemptReviewStatusInvalid",
  binding_missing: "common.errors.apiCodeReasons.businessWorkflow.bindingMissing",
  callback_binding_invalid: "common.errors.apiCodeReasons.businessWorkflow.callbackBindingInvalid",
  callback_signing_secret_missing:
    "common.errors.apiCodeReasons.businessWorkflow.callbackSigningSecretMissing",
  callback_token_expired: "common.errors.apiCodeReasons.businessWorkflow.callbackTokenExpired",
  callback_token_invalid: "common.errors.apiCodeReasons.businessWorkflow.callbackTokenInvalid",
  callback_token_required: "common.errors.apiCodeReasons.businessWorkflow.callbackTokenRequired",
  candidate_not_assigned: "common.errors.apiCodeReasons.businessWorkflow.candidateNotAssigned",
  close_requires_published: "common.errors.apiCodeReasons.businessWorkflow.closeRequiresPublished",
  code_already_exists: "common.errors.apiCodeReasons.businessWorkflow.codeAlreadyExists",
  code_required: "common.errors.apiCodeReasons.businessWorkflow.codeRequired",
  completion_requires_in_progress:
    "common.errors.apiCodeReasons.businessWorkflow.completionRequiresInProgress",
  config_invalid: "common.errors.apiCodeReasons.businessWorkflow.configInvalid",
  confirmed_by_required: "common.errors.apiCodeReasons.businessWorkflow.confirmedByRequired",
  course_not_found: "common.errors.apiCodeReasons.businessWorkflow.courseNotFound",
  course_reset_not_available:
    "common.errors.apiCodeReasons.businessWorkflow.courseResetNotAvailable",
  course_scheme_catalog_missing:
    "common.errors.apiCodeReasons.businessWorkflow.courseSchemeCatalogMissing",
  course_task_not_in_record: "common.errors.apiCodeReasons.businessWorkflow.courseTaskNotInRecord",
  current_user_member_inactive:
    "common.errors.apiCodeReasons.businessWorkflow.currentUserMemberInactive",
  database_unavailable: "common.errors.apiCodeReasons.businessWorkflow.databaseUnavailable",
  destroy_source_type_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.destroySourceTypeInvalid",
  decided_by_required: "common.errors.apiCodeReasons.businessWorkflow.decidedByRequired",
  destroy_request_id_missing:
    "common.errors.apiCodeReasons.businessWorkflow.destroyRequestIdMissing",
  duplicate: "common.errors.apiCodeReasons.businessWorkflow.duplicate",
  duplicate_member_user_id: "common.errors.apiCodeReasons.businessWorkflow.duplicateMemberUserId",
  duplicate_role_for_member: "common.errors.apiCodeReasons.businessWorkflow.duplicateRoleForMember",
  duplicate_seat_binding: "common.errors.apiCodeReasons.businessWorkflow.duplicateSeatBinding",
  early_submit_not_allowed: "common.errors.apiCodeReasons.businessWorkflow.earlySubmitNotAllowed",
  end_only_from_published: "common.errors.apiCodeReasons.businessWorkflow.endOnlyFromPublished",
  ended: "common.errors.apiCodeReasons.businessWorkflow.ended",
  exam_access_denied: "common.errors.apiCodeReasons.businessWorkflow.examAccessDenied",
  exam_api_not_configured: "common.errors.apiCodeReasons.businessWorkflow.examApiNotConfigured",
  exam_api_unavailable: "common.errors.apiCodeReasons.businessWorkflow.examApiUnavailable",
  exam_binding_unavailable: "common.errors.apiCodeReasons.businessWorkflow.examBindingUnavailable",
  exam_bridge_rejected: "common.errors.apiCodeReasons.businessWorkflow.examBridgeRejected",
  exam_invalid_payload: "common.errors.apiCodeReasons.businessWorkflow.examInvalidPayload",
  exam_invalid_token: "common.errors.apiCodeReasons.businessWorkflow.examInvalidToken",
  exam_options_unavailable: "common.errors.apiCodeReasons.businessWorkflow.examOptionsUnavailable",
  exam_paper_not_found: "common.errors.apiCodeReasons.businessWorkflow.examPaperNotFound",
  exam_result_requires_published:
    "common.errors.apiCodeReasons.businessWorkflow.examResultRequiresPublished",
  exam_step_locked: "common.errors.apiCodeReasons.businessWorkflow.examStepLocked",
  exam_step_paper_binding_missing:
    "common.errors.apiCodeReasons.businessWorkflow.examStepPaperBindingMissing",
  exam_step_pass_score_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.examStepPassScoreInvalid",
  exam_step_pass_score_missing:
    "common.errors.apiCodeReasons.businessWorkflow.examStepPassScoreMissing",
  exam_step_required: "common.errors.apiCodeReasons.businessWorkflow.examStepRequired",
  execution_config_network_mode_removed:
    "common.errors.apiCodeReasons.businessWorkflow.executionConfigNetworkModeRemoved",
  execution_image_declared_ports_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.executionImageDeclaredPortsInvalid",
  execution_image_default_spec_required:
    "common.errors.apiCodeReasons.businessWorkflow.executionImageDefaultSpecRequired",
  execution_image_identity_mismatch:
    "common.errors.apiCodeReasons.businessWorkflow.executionImageIdentityMismatch",
  execution_image_kind_not_allowed:
    "common.errors.apiCodeReasons.businessWorkflow.executionImageKindNotAllowed",
  execution_image_kind_required:
    "common.errors.apiCodeReasons.businessWorkflow.executionImageKindRequired",
  execution_image_required: "common.errors.apiCodeReasons.businessWorkflow.executionImageRequired",
  execution_member_observer_conflict:
    "common.errors.apiCodeReasons.businessWorkflow.executionMemberObserverConflict",
  experiment_status_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.experimentStatusInvalid",
  expired_auto_submitted: "common.errors.apiCodeReasons.businessWorkflow.expiredAutoSubmitted",
  flag_completion_condition_missing:
    "common.errors.apiCodeReasons.businessWorkflow.flagCompletionConditionMissing",
  flag_task_requires_flags_endpoint:
    "common.errors.apiCodeReasons.businessWorkflow.flagTaskRequiresFlagsEndpoint",
  generation_failed: "common.errors.apiCodeReasons.businessWorkflow.generationFailed",
  generation_not_deletable: "common.errors.apiCodeReasons.businessWorkflow.generationNotDeletable",
  generation_not_found: "common.errors.apiCodeReasons.businessWorkflow.generationNotFound",
  generation_not_reviewable:
    "common.errors.apiCodeReasons.businessWorkflow.generationNotReviewable",
  has_attempt_records: "common.errors.apiCodeReasons.businessWorkflow.hasAttemptRecords",
  image_snapshot_actor_required:
    "common.errors.apiCodeReasons.businessWorkflow.imageSnapshotActorRequired",
  inactive_member_cannot_start_public_course:
    "common.errors.apiCodeReasons.businessWorkflow.inactiveMemberCannotStartPublicCourse",
  incomplete: "common.errors.apiCodeReasons.businessWorkflow.incomplete",
  instance_business_context_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.instanceBusinessContextInvalid",
  instance_contract_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.instanceContractInvalid",
  instance_source_type_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.instanceSourceTypeInvalid",
  integration_base_url_not_configured:
    "common.errors.apiCodeReasons.businessWorkflow.integrationBaseUrlNotConfigured",
  integration_setting_key_unknown:
    "common.errors.apiCodeReasons.businessWorkflow.integrationSettingKeyUnknown",
  internal_callback_token_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.internalCallbackTokenInvalid",
  internal_callback_token_missing:
    "common.errors.apiCodeReasons.businessWorkflow.internalCallbackTokenMissing",
  invalid_course_binding: "common.errors.apiCodeReasons.businessWorkflow.invalidCourseBinding",
  invalid_execution_status: "common.errors.apiCodeReasons.businessWorkflow.invalidExecutionStatus",
  invalid_external_id: "common.errors.apiCodeReasons.businessWorkflow.invalidExternalId",
  invalid_lifecycle_status: "common.errors.apiCodeReasons.businessWorkflow.invalidLifecycleStatus",
  invalid_member_id: "common.errors.apiCodeReasons.businessWorkflow.invalidMemberId",
  invalid_member_status: "common.errors.apiCodeReasons.businessWorkflow.invalidMemberStatus",
  invalid_paper_binding: "common.errors.apiCodeReasons.businessWorkflow.invalidPaperBinding",
  invalid_status_transition:
    "common.errors.apiCodeReasons.businessWorkflow.invalidStatusTransition",
  invalid_step_node_type: "common.errors.apiCodeReasons.businessWorkflow.invalidStepNodeType",
  invalid_unlock_template: "common.errors.apiCodeReasons.businessWorkflow.invalidUnlockTemplate",
  items_required: "common.errors.apiCodeReasons.businessWorkflow.itemsRequired",
  late_entry_disabled: "common.errors.apiCodeReasons.businessWorkflow.lateEntryDisabled",
  late_entry_window_exceeded:
    "common.errors.apiCodeReasons.businessWorkflow.lateEntryWindowExceeded",
  learner_entry_not_found: "common.errors.apiCodeReasons.businessWorkflow.learnerEntryNotFound",
  learner_message_not_found: "common.errors.apiCodeReasons.businessWorkflow.learnerMessageNotFound",
  lesson_locked: "common.errors.apiCodeReasons.businessWorkflow.lessonLocked",
  lesson_not_in_course: "common.errors.apiCodeReasons.businessWorkflow.lessonNotInCourse",
  lesson_not_in_plan_snapshot:
    "common.errors.apiCodeReasons.businessWorkflow.lessonNotInPlanSnapshot",
  locked: "common.errors.apiCodeReasons.businessWorkflow.locked",
  management_access_required:
    "common.errors.apiCodeReasons.businessWorkflow.managementAccessRequired",
  manual_release_requires_published:
    "common.errors.apiCodeReasons.businessWorkflow.manualReleaseRequiresPublished",
  manual_release_step_requires_manual_unlock:
    "common.errors.apiCodeReasons.businessWorkflow.manualReleaseStepRequiresManualUnlock",
  max_count_exceeded: "common.errors.apiCodeReasons.businessWorkflow.maxCountExceeded",
  mcp_execution_contract_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.mcpExecutionContractInvalid",
  member_not_assigned: "common.errors.apiCodeReasons.businessWorkflow.memberNotAssigned",
  member_not_found: "common.errors.apiCodeReasons.businessWorkflow.memberNotFound",
  member_not_found_or_inactive:
    "common.errors.apiCodeReasons.businessWorkflow.memberNotFoundOrInactive",
  member_role_conflict: "common.errors.apiCodeReasons.businessWorkflow.memberRoleConflict",
  members_inactive: "common.errors.apiCodeReasons.businessWorkflow.membersInactive",
  members_missing: "common.errors.apiCodeReasons.businessWorkflow.membersMissing",
  members_not_in_directory: "common.errors.apiCodeReasons.businessWorkflow.membersNotInDirectory",
  mixed_instance_kinds: "common.errors.apiCodeReasons.businessWorkflow.mixedInstanceKinds",
  no_learner_submissions: "common.errors.apiCodeReasons.businessWorkflow.noLearnerSubmissions",
  no_outdated_items_selected:
    "common.errors.apiCodeReasons.businessWorkflow.noOutdatedItemsSelected",
  non_execution_member_seat_binding:
    "common.errors.apiCodeReasons.businessWorkflow.nonExecutionMemberSeatBinding",
  non_execution_role_camp_binding:
    "common.errors.apiCodeReasons.businessWorkflow.nonExecutionRoleCampBinding",
  not_deletable: "common.errors.apiCodeReasons.businessWorkflow.notDeletable",
  not_draft: "common.errors.apiCodeReasons.businessWorkflow.notDraft",
  not_in_progress: "common.errors.apiCodeReasons.businessWorkflow.notInProgress",
  not_open: "common.errors.apiCodeReasons.businessWorkflow.notOpen",
  not_owned_by_member: "common.errors.apiCodeReasons.businessWorkflow.notOwnedByMember",
  not_pending: "common.errors.apiCodeReasons.businessWorkflow.notPending",
  not_pending_dispatch: "common.errors.apiCodeReasons.businessWorkflow.notPendingDispatch",
  not_startable: "common.errors.apiCodeReasons.businessWorkflow.notStartable",
  not_started: "common.errors.apiCodeReasons.businessWorkflow.notStarted",
  not_visible_to_member: "common.errors.apiCodeReasons.businessWorkflow.notVisibleToMember",
  offline_requires_approved_shared_entry:
    "common.errors.apiCodeReasons.businessWorkflow.offlineRequiresApprovedSharedEntry",
  operator_context_invalid: "common.errors.apiCodeReasons.businessWorkflow.operatorContextInvalid",
  operator_role_invalid: "common.errors.apiCodeReasons.businessWorkflow.operatorRoleInvalid",
  parent_generation_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.parentGenerationInvalid",
  plan_binding_completed: "common.errors.apiCodeReasons.businessWorkflow.planBindingCompleted",
  plan_binding_historical: "common.errors.apiCodeReasons.businessWorkflow.planBindingHistorical",
  plan_binding_status_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.planBindingStatusInvalid",
  plan_exam_task_paper_binding_missing:
    "common.errors.apiCodeReasons.businessWorkflow.planExamTaskPaperBindingMissing",
  plan_review_only_after_end:
    "common.errors.apiCodeReasons.businessWorkflow.planReviewOnlyAfterEnd",
  plan_snapshot_missing: "common.errors.apiCodeReasons.businessWorkflow.planSnapshotMissing",
  plan_start_requires_published:
    "common.errors.apiCodeReasons.businessWorkflow.planStartRequiresPublished",
  prepare_projection_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.prepareProjectionInvalid",
  prepare_request_mismatch: "common.errors.apiCodeReasons.businessWorkflow.prepareRequestMismatch",
  project_binding_completed:
    "common.errors.apiCodeReasons.businessWorkflow.projectBindingCompleted",
  project_binding_historical:
    "common.errors.apiCodeReasons.businessWorkflow.projectBindingHistorical",
  project_binding_status_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.projectBindingStatusInvalid",
  project_instance_completed:
    "common.errors.apiCodeReasons.businessWorkflow.projectInstanceCompleted",
  project_instance_missing: "common.errors.apiCodeReasons.businessWorkflow.projectInstanceMissing",
  project_instance_status_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.projectInstanceStatusInvalid",
  project_review_only_after_end:
    "common.errors.apiCodeReasons.businessWorkflow.projectReviewOnlyAfterEnd",
  project_start_requires_published:
    "common.errors.apiCodeReasons.businessWorkflow.projectStartRequiresPublished",
  project_step_locked: "common.errors.apiCodeReasons.businessWorkflow.projectStepLocked",
  public_asset_not_found: "common.errors.apiCodeReasons.businessWorkflow.publicAssetNotFound",
  public_course_start_requires_published:
    "common.errors.apiCodeReasons.businessWorkflow.publicCourseStartRequiresPublished",
  publish_only_from_draft: "common.errors.apiCodeReasons.businessWorkflow.publishOnlyFromDraft",
  publish_requires_draft: "common.errors.apiCodeReasons.businessWorkflow.publishRequiresDraft",
  publish_requires_targets: "common.errors.apiCodeReasons.businessWorkflow.publishRequiresTargets",
  published_by_required: "common.errors.apiCodeReasons.businessWorkflow.publishedByRequired",
  quota_owner_change_forbidden:
    "common.errors.apiCodeReasons.businessWorkflow.quotaOwnerChangeForbidden",
  quota_owner_member_not_found:
    "common.errors.apiCodeReasons.businessWorkflow.quotaOwnerMemberNotFound",
  quota_owner_not_task_tester:
    "common.errors.apiCodeReasons.businessWorkflow.quotaOwnerNotTaskTester",
  quota_owner_user_id_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.quotaOwnerUserIdInvalid",
  readonly_published: "common.errors.apiCodeReasons.businessWorkflow.readonlyPublished",
  reentry_disabled: "common.errors.apiCodeReasons.businessWorkflow.reentryDisabled",
  referenced_by_exams: "common.errors.apiCodeReasons.businessWorkflow.referencedByExams",
  release_projection_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.releaseProjectionInvalid",
  release_request_mismatch: "common.errors.apiCodeReasons.businessWorkflow.releaseRequestMismatch",
  release_topology_instance_mismatch:
    "common.errors.apiCodeReasons.businessWorkflow.releaseTopologyInstanceMismatch",
  required_for_version_create:
    "common.errors.apiCodeReasons.businessWorkflow.requiredForVersionCreate",
  requires_dispatched_task: "common.errors.apiCodeReasons.businessWorkflow.requiresDispatchedTask",
  requires_ended_status: "common.errors.apiCodeReasons.businessWorkflow.requiresEndedStatus",
  reset_requires_latest_attempt:
    "common.errors.apiCodeReasons.businessWorkflow.resetRequiresLatestAttempt",
  reset_requires_started_attempt:
    "common.errors.apiCodeReasons.businessWorkflow.resetRequiresStartedAttempt",
  result_task_requires_submission_flow:
    "common.errors.apiCodeReasons.businessWorkflow.resultTaskRequiresSubmissionFlow",
  reuse_requires_approved_shared_entry:
    "common.errors.apiCodeReasons.businessWorkflow.reuseRequiresApprovedSharedEntry",
  review_decision_requires_pending_entry:
    "common.errors.apiCodeReasons.businessWorkflow.reviewDecisionRequiresPendingEntry",
  review_ended_only: "common.errors.apiCodeReasons.businessWorkflow.reviewEndedOnly",
  review_submit_owner_required:
    "common.errors.apiCodeReasons.businessWorkflow.reviewSubmitOwnerRequired",
  review_submit_requires_draft_version:
    "common.errors.apiCodeReasons.businessWorkflow.reviewSubmitRequiresDraftVersion",
  role_unmapped: "common.errors.apiCodeReasons.businessWorkflow.roleUnmapped",
  roles_missing: "common.errors.apiCodeReasons.businessWorkflow.rolesMissing",
  runtime_params_network_contract_managed:
    "common.errors.apiCodeReasons.businessWorkflow.runtimeParamsNetworkContractManaged",
  runtime_params_placement_forbidden:
    "common.errors.apiCodeReasons.businessWorkflow.runtimeParamsPlacementForbidden",
  runtime_target_snapshot_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.runtimeTargetSnapshotInvalid",
  schedule_not_ready: "common.errors.apiCodeReasons.businessWorkflow.scheduleNotReady",
  schedule_window_invalid: "common.errors.apiCodeReasons.businessWorkflow.scheduleWindowInvalid",
  schema_not_ready: "common.errors.apiCodeReasons.businessWorkflow.schemaNotReady",
  scheme_catalog_course_unflushed:
    "common.errors.apiCodeReasons.businessWorkflow.schemeCatalogCourseUnflushed",
  scheme_catalog_missing: "common.errors.apiCodeReasons.businessWorkflow.schemeCatalogMissing",
  scheme_create_requires_draft:
    "common.errors.apiCodeReasons.businessWorkflow.schemeCreateRequiresDraft",
  scheme_version_create_requires_draft_or_shared:
    "common.errors.apiCodeReasons.businessWorkflow.schemeVersionCreateRequiresDraftOrShared",
  scheme_version_mismatch: "common.errors.apiCodeReasons.businessWorkflow.schemeVersionMismatch",
  scheme_version_not_found: "common.errors.apiCodeReasons.businessWorkflow.schemeVersionNotFound",
  scheme_version_not_published:
    "common.errors.apiCodeReasons.businessWorkflow.schemeVersionNotPublished",
  seats_not_fully_bound: "common.errors.apiCodeReasons.businessWorkflow.seatsNotFullyBound",
  session_required: "common.errors.apiCodeReasons.businessWorkflow.sessionRequired",
  setting_invalid: "common.errors.apiCodeReasons.businessWorkflow.settingInvalid",
  setting_missing: "common.errors.apiCodeReasons.businessWorkflow.settingMissing",
  setting_payload_invalid: "common.errors.apiCodeReasons.businessWorkflow.settingPayloadInvalid",
  severity_invalid: "common.errors.apiCodeReasons.businessWorkflow.severityInvalid",
  share_forbidden: "common.errors.apiCodeReasons.businessWorkflow.shareForbidden",
  share_public_requires_review_pipeline:
    "common.errors.apiCodeReasons.businessWorkflow.sharePublicRequiresReviewPipeline",
  snapshot_catalog_missing: "common.errors.apiCodeReasons.businessWorkflow.snapshotCatalogMissing",
  snapshot_design_incomplete:
    "common.errors.apiCodeReasons.businessWorkflow.snapshotDesignIncomplete",
  snapshot_missing: "common.errors.apiCodeReasons.businessWorkflow.snapshotMissing",
  snapshot_scheme_missing: "common.errors.apiCodeReasons.businessWorkflow.snapshotSchemeMissing",
  snapshot_up_to_date: "common.errors.apiCodeReasons.businessWorkflow.snapshotUpToDate",
  source_course_not_found: "common.errors.apiCodeReasons.businessWorkflow.sourceCourseNotFound",
  source_missing: "common.errors.apiCodeReasons.businessWorkflow.sourceMissing",
  source_snapshot_forbidden:
    "common.errors.apiCodeReasons.businessWorkflow.sourceSnapshotForbidden",
  staff_execution_role_conflict:
    "common.errors.apiCodeReasons.businessWorkflow.staffExecutionRoleConflict",
  standalone_runtime_target_snapshot_forbidden:
    "common.errors.apiCodeReasons.businessWorkflow.standaloneRuntimeTargetSnapshotForbidden",
  status_contract_invalid: "common.errors.apiCodeReasons.businessWorkflow.statusContractInvalid",
  status_transition_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.statusTransitionInvalid",
  step_bound_course_not_found:
    "common.errors.apiCodeReasons.businessWorkflow.stepBoundCourseNotFound",
  step_completion_summary_required:
    "common.errors.apiCodeReasons.businessWorkflow.stepCompletionSummaryRequired",
  step_course_binding_missing:
    "common.errors.apiCodeReasons.businessWorkflow.stepCourseBindingMissing",
  step_course_binding_required:
    "common.errors.apiCodeReasons.businessWorkflow.stepCourseBindingRequired",
  step_exam_binding_required:
    "common.errors.apiCodeReasons.businessWorkflow.stepExamBindingRequired",
  step_not_found: "common.errors.apiCodeReasons.businessWorkflow.stepNotFound",
  step_scheduled_release_only_for_scheduled_unlock:
    "common.errors.apiCodeReasons.businessWorkflow.stepScheduledReleaseOnlyForScheduledUnlock",
  step_scheduled_release_required:
    "common.errors.apiCodeReasons.businessWorkflow.stepScheduledReleaseRequired",
  step_source_course_scheme_missing:
    "common.errors.apiCodeReasons.businessWorkflow.stepSourceCourseSchemeMissing",
  step_title_required: "common.errors.apiCodeReasons.businessWorkflow.stepTitleRequired",
  step_unlock_rule_summary_required:
    "common.errors.apiCodeReasons.businessWorkflow.stepUnlockRuleSummaryRequired",
  steps_edit_only_in_draft: "common.errors.apiCodeReasons.businessWorkflow.stepsEditOnlyInDraft",
  storage_required_fields_missing:
    "common.errors.apiCodeReasons.businessWorkflow.storageRequiredFieldsMissing",
  submit_payload_invalid: "common.errors.apiCodeReasons.businessWorkflow.submitPayloadInvalid",
  submit_payloads_missing: "common.errors.apiCodeReasons.businessWorkflow.submitPayloadsMissing",
  submit_request_id_missing: "common.errors.apiCodeReasons.businessWorkflow.submitRequestIdMissing",
  target_members_invalid: "common.errors.apiCodeReasons.businessWorkflow.targetMembersInvalid",
  target_members_manage_requires_active_release:
    "common.errors.apiCodeReasons.businessWorkflow.targetMembersManageRequiresActiveRelease",
  target_members_manage_requires_targeted_release:
    "common.errors.apiCodeReasons.businessWorkflow.targetMembersManageRequiresTargetedRelease",
  target_members_not_found: "common.errors.apiCodeReasons.businessWorkflow.targetMembersNotFound",
  target_members_required: "common.errors.apiCodeReasons.businessWorkflow.targetMembersRequired",
  target_service_snapshot_removed:
    "common.errors.apiCodeReasons.businessWorkflow.targetServiceSnapshotRemoved",
  task_not_flag: "common.errors.apiCodeReasons.businessWorkflow.taskNotFlag",
  task_not_in_record: "common.errors.apiCodeReasons.businessWorkflow.taskNotInRecord",
  task_submission_not_found: "common.errors.apiCodeReasons.businessWorkflow.taskSubmissionNotFound",
  tasks_not_visible: "common.errors.apiCodeReasons.businessWorkflow.tasksNotVisible",
  teaching_plan_missing: "common.errors.apiCodeReasons.businessWorkflow.teachingPlanMissing",
  teaching_plan_task_inactive:
    "common.errors.apiCodeReasons.businessWorkflow.teachingPlanTaskInactive",
  template_version_mismatch:
    "common.errors.apiCodeReasons.businessWorkflow.templateVersionMismatch",
  terminal_readonly: "common.errors.apiCodeReasons.businessWorkflow.terminalReadonly",
  test_instance_binding_runtime_kind_required:
    "common.errors.apiCodeReasons.businessWorkflow.testInstanceBindingRuntimeKindRequired",
  test_instance_binding_spec_required:
    "common.errors.apiCodeReasons.businessWorkflow.testInstanceBindingSpecRequired",
  topology_attachment_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.topologyAttachmentInvalid",
  topology_binding_incomplete:
    "common.errors.apiCodeReasons.businessWorkflow.topologyBindingIncomplete",
  topology_binding_not_found:
    "common.errors.apiCodeReasons.businessWorkflow.topologyBindingNotFound",
  topology_business_context_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.topologyBusinessContextInvalid",
  topology_evidence_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.topologyEvidenceInvalid",
  topology_instance_id_missing:
    "common.errors.apiCodeReasons.businessWorkflow.topologyInstanceIdMissing",
  topology_not_prepared: "common.errors.apiCodeReasons.businessWorkflow.topologyNotPrepared",
  topology_request_id_missing:
    "common.errors.apiCodeReasons.businessWorkflow.topologyRequestIdMissing",
  topology_version_not_published:
    "common.errors.apiCodeReasons.businessWorkflow.topologyVersionNotPublished",
  unknown_camp_code: "common.errors.apiCodeReasons.businessWorkflow.unknownCampCode",
  unknown_reference: "common.errors.apiCodeReasons.businessWorkflow.unknownReference",
  unknown_seat_code: "common.errors.apiCodeReasons.businessWorkflow.unknownSeatCode",
  unsupported_status_action:
    "common.errors.apiCodeReasons.businessWorkflow.unsupportedStatusAction",
  workspace_not_visible: "common.errors.apiCodeReasons.businessWorkflow.workspaceNotVisible",
  write_requires_running_activity:
    "common.errors.apiCodeReasons.businessWorkflow.writeRequiresRunningActivity",
  actor_username_required: "common.errors.apiCodeReasons.businessWorkflow.actorUsernameRequired",
  archived_immutable: "common.errors.apiCodeReasons.businessWorkflow.archivedImmutable",
  create_status_invalid: "common.errors.apiCodeReasons.businessWorkflow.createStatusInvalid",
  delete_conflict: "common.errors.apiCodeReasons.businessWorkflow.deleteConflict",
  invalid_status_filter: "common.errors.apiCodeReasons.businessWorkflow.invalidStatusFilter",
  mode_immutable: "common.errors.apiCodeReasons.businessWorkflow.modeImmutable",
  mode_invalid: "common.errors.apiCodeReasons.businessWorkflow.modeInvalid",
  regression_target_version_not_supported:
    "common.errors.apiCodeReasons.businessWorkflow.regressionTargetVersionNotSupported",
  role_nodes_missing: "common.errors.apiCodeReasons.businessWorkflow.roleNodesMissing",
  seats_missing: "common.errors.apiCodeReasons.businessWorkflow.seatsMissing",
  source_experiment_mode_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.sourceExperimentModeInvalid",
  source_experiment_not_found:
    "common.errors.apiCodeReasons.businessWorkflow.sourceExperimentNotFound",
  source_target_mismatch: "common.errors.apiCodeReasons.businessWorkflow.sourceTargetMismatch",
  source_task_execution_mode_invalid:
    "common.errors.apiCodeReasons.businessWorkflow.sourceTaskExecutionModeInvalid",
  source_task_immutable: "common.errors.apiCodeReasons.businessWorkflow.sourceTaskImmutable",
  source_task_not_completed: "common.errors.apiCodeReasons.businessWorkflow.sourceTaskNotCompleted",
  source_task_not_confirmed: "common.errors.apiCodeReasons.businessWorkflow.sourceTaskNotConfirmed",
  source_task_not_found: "common.errors.apiCodeReasons.businessWorkflow.sourceTaskNotFound",
  source_task_not_supported: "common.errors.apiCodeReasons.businessWorkflow.sourceTaskNotSupported",
  source_task_required: "common.errors.apiCodeReasons.businessWorkflow.sourceTaskRequired",
  status_update_forbidden: "common.errors.apiCodeReasons.businessWorkflow.statusUpdateForbidden",
  target_immutable: "common.errors.apiCodeReasons.businessWorkflow.targetImmutable",
  target_not_found: "common.errors.apiCodeReasons.businessWorkflow.targetNotFound",
  target_version_immutable: "common.errors.apiCodeReasons.businessWorkflow.targetVersionImmutable",
  target_version_not_found: "common.errors.apiCodeReasons.businessWorkflow.targetVersionNotFound",
  target_version_required: "common.errors.apiCodeReasons.businessWorkflow.targetVersionRequired",
  target_version_target_mismatch:
    "common.errors.apiCodeReasons.businessWorkflow.targetVersionTargetMismatch",
};
